import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  EXPORT_TYPES,
  MODULES,
  TABLE_FILTER_KEYS,
  USER_ROLES,
} from '../../../../../common/constants';
import { isSalesUser } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import { REQUEST_USER_EXPORT } from '../../../graphql/Mutations';
import EndUsersTable from '../components/EndUsersTable';

const roleFilter = [USER_ROLES?.USER?.key];

const EndUsers = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    state: { currentUser },
  } = useContext(AppContext);

  const [requestUserExport] = useMutation(REQUEST_USER_EXPORT, {
    onError: () => {},
  });

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestUserExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.USER,
        },
        filter: {
          search: exportFilter?.search,
          roles:
            exportFilter?.role?.length > 0 ? exportFilter?.role : roleFilter,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          isActive: exportFilter?.status,
          isArchived: exportFilter?.isArchived,
          types:
            exportFilter?.billingCycle?.length > 0
              ? exportFilter?.billingCycle
              : undefined,
          names:
            exportFilter?.planSubscribed?.length > 0
              ? exportFilter?.planSubscribed
              : undefined,
          libraryIds: exportFilter?.name,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.END_USERS}</div>
      </Portal>
      {!isSalesUser(currentUser) && (
        <>
          <Portal portalId="header-right-content">
            <Button
              className="common-button ml-16"
              size="middle"
              icon={<ExportOutlined />}
              onClick={() => setIsModalOpen(true)}
              loading={isExportLoading}
            >
              Export
            </Button>
          </Portal>
          <Portal portalId="header-right-content-phones">
            <Button
              className="common-button ml-16"
              size="middle"
              icon={<ExportOutlined />}
              onClick={() => setIsModalOpen(true)}
              loading={isExportLoading}
            >
              Export
            </Button>
          </Portal>
        </>
      )}
      <ResetFilterButton tableKey={TABLE_FILTER_KEYS.SYSTEM_USERS_END_USERS} />
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="full-height-without-nav">
        <EndUsersTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
        />
      </Card>
    </>
  );
};

export default EndUsers;
